'use client';

import aboutImage from '@/assets/images/about-us/about.png';
import bannerImage from '@/assets/images/about-us/banner.png';
import feature1Image from '@/assets/images/about-us/feature-1.png';
import feature2Image from '@/assets/images/about-us/feature-2.png';
import feature3Image from '@/assets/images/about-us/feature-3.png';
import bannerImageMobile from '@/assets/images/about-us/mobile-banner.png';
import FeaturedCategories from '@/components/FeaturedCategories';

import Image from 'next/image';
import { useRef } from 'react';
import AboutReviews from './aboutReviews';

const AboutUsPage = () => {
  const containerRef = useRef(null);
  let isDragging = false;
  let startX;
  let scrollLeft;

  const handleMouseDown = e => {
    isDragging = true;
    containerRef.current.style.cursor = 'grabbing';
    containerRef.current.style.userSelect = 'none'; // 禁用文本选择
    startX = e.pageX - containerRef.current.offsetLeft;
    scrollLeft = containerRef.current.scrollLeft;
  };

  const handleMouseLeave = () => {
    isDragging = false;
    containerRef.current.style.cursor = 'grab';
    containerRef.current.style.userSelect = ''; // 恢复文本选择
  };

  const handleMouseUp = () => {
    isDragging = false;
    containerRef.current.style.cursor = 'grab';
    containerRef.current.style.userSelect = ''; // 恢复文本选择
  };

  const handleMouseMove = e => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - containerRef.current.offsetLeft;
    const walk = (x - startX) * 2; // 滚动速度

    containerRef.current.scrollLeft = scrollLeft - walk;
  };

  return (
    <div className='pb-[60px]'>
      <Image
        src={bannerImageMobile}
        className='block h-auto w-full lg_hidden'
        alt=''
        priority
      />
      <Image
        src={bannerImage}
        className='hidden h-auto w-full lg_block'
        alt=''
        priority
      />

      <div className='block bg-[#EFEFEF] p-[20px] lg_hidden'>
        <p className='font-poppins text-[30px] font-[700] uppercase text-title'>Bringing Nature Closer to Home </p>
        <p className='mt-[10px] font-sans text-title'>
          At Kingsyard, we design bird feeders and houses that bring joy to you-and safe have to your feathered friends.
        </p>
      </div>

      <div className='mx-auto mt-[40px] flex w-[1440px] max-w-full lg_mt-[60px] lg_gap-x-[85px]'>
        <div className='flex flex-1 flex-col items-start'>
          <h1 className='mb-[20px] pl-[15px] font-poppins text-[22px] font-[600] text-title lg_pl-0 lg_text-[30px]'>
            About Kingsyard
          </h1>
          <Image
            src={aboutImage}
            className='block h-auto w-full lg_hidden'
            alt=''
            priority
          />

          <div className='flex flex-col gap-y-[20px] px-[15px] pt-[20px] font-sans text-sm leading-[1.4] text-title lg_px-0 lg_pt-0 lg_text-[16px]'>
            <p>
              Founded in 2012, Kingsyard began with a simple passion—for birds, nature, and the joy of backyard
              birdwatching. Since then, we’ve been dedicated to designing durable, high-quality bird feeders and
              accessories that help bring birds closer to home.
            </p>
            <p>
              We believe every person plays a role in protecting nature. That’s why our products not only serve birds
              with care but also help people better understand bird habits and the beauty of their presence.
            </p>
            <p>
              At Kingsyard, our mission is to inspire more people to love and care for birds—and to create a backyard
              sanctuary where nature feels just a little bit closer.
            </p>
          </div>
        </div>
        <div className='hidden w-[755px] lg_block'>
          <Image
            src={aboutImage}
            className='h-auto w-full'
            alt=''
            priority
          />
        </div>
      </div>

      <div className='mx-auto mt-[40px] w-[1440px] max-w-full lg_mt-[80px]'>
        <h2 className='mb-[20px] pl-[15px] font-poppins text-[22px] font-[600] text-title lg_mb-[40px] lg_pl-0 lg_text-[30px]'>
          What We Stand
        </h2>
        <>
          <div className='mx-[15px] mt-[20px] lg_hidden'>
            <div
              id='scroll-container'
              ref={containerRef}
              onMouseDown={handleMouseDown}
              onMouseLeave={handleMouseLeave}
              onMouseUp={handleMouseUp}
              onMouseMove={handleMouseMove}
              className='flex overflow-x-auto whitespace-nowrap pb-[20px]'
            >
              <div className='mr-[20px] flex min-h-[410px] w-[300px] shrink-0 flex-col items-center justify-center'>
                <div className='flex h-full w-full flex-col gap-y-[10px]'>
                  <Image
                    src={feature1Image}
                    className='h-[300px] w-[300px]'
                    alt=''
                  />
                  <p className='font-poppins font-[600] text-[20x] text-title'>Quality That Lasts</p>
                  <p className='whitespace-normal font-sans text-sm text-title'>
                    Built to withstand time and weather-so you can feed the birds worry-free, season after season.
                  </p>
                </div>
              </div>

              <div className='mr-[20px] flex min-h-[410px] w-[300px] shrink-0 flex-col items-center justify-center'>
                <div className='flex h-full w-full flex-col gap-y-[10px]'>
                  <Image
                    src={feature2Image}
                    className='h-[300px] w-[300px]'
                    alt=''
                  />
                  <p className='font-poppins font-[600] text-[20x] text-title'>A Brand You Can Trust </p>
                  <p className='whitespace-normal font-sans text-sm text-title'>
                    Thousands of bird lovers choose Kingsyard. Your satisfaction is our mission.
                  </p>
                </div>
              </div>

              <div className='mr-[20px] flex min-h-[410px] w-[300px] shrink-0 flex-col items-center justify-center'>
                <div className='flex h-full w-full flex-col gap-y-[10px]'>
                  <Image
                    src={feature3Image}
                    className='h-[300px] w-[300px]'
                    alt=''
                  />
                  <p className='font-poppins font-[600] text-[20x] text-title'>Connection to Nature </p>
                  <p className='whitespace-normal font-sans text-sm text-title'>
                    We believe bird feeding is more than a hobby-it&apos;s a way to feel peace and joy, everyday.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className='hidden grid-cols-3 gap-[45px] lg_grid'>
            <div className='flex flex-col gap-y-[20px]'>
              <Image
                src={feature1Image}
                className='h-auto w-full'
                alt=''
              />
              <p className='font-poppins text-[24px] font-[600] text-title'>Quality That Lasts</p>
              <p className='font-sans text-[18px] text-title'>
                Built to withstand time and weather-so you can feed the birds worry-free, season after season.
              </p>
            </div>
            <div className='flex flex-col gap-y-[20px]'>
              <Image
                src={feature2Image}
                className='h-auto w-full'
                alt=''
              />
              <p className='font-poppins text-[24px] font-[600] text-title'>A Brand You Can Trust </p>
              <p className='font-sans text-[18px] text-title'>
                Thousands of bird lovers choose Kingsyard. Your satisfaction is our mission.
              </p>
            </div>
            <div className='flex flex-col gap-y-[20px]'>
              <Image
                src={feature3Image}
                className='h-auto w-full'
                alt=''
              />
              <p className='font-poppins text-[24px] font-[600] text-title'>Connection to Nature </p>
              <p className='font-sans text-[18px] text-title'>
                We believe bird feeding is more than a hobby-it&apos;s a way to feel peace and joy, everyday.
              </p>
            </div>
          </div>
        </>
      </div>

      <div className='mx-auto mt-[80px] w-[1440px] max-w-full'>
        <AboutReviews />
      </div>

      <div className='mt-[20px]'>
        <FeaturedCategories hideTitile />
      </div>
    </div>
  );
};

export default AboutUsPage;
